import React from 'react';
import PropTypes from 'prop-types';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  root: {
    background: 'transparent',
    boxShadow: 'none',
    '&.MuiToggleButtonGroup-root': {
      display: 'block',
    },
    '& .MuiToggleButtonGroup-grouped': {
      padding: '0 2px',
      height: '24px',
      minWidth: '32px',
      color: '#00BF75',
      fontWeight: 'bold',
      border: 0,
      '&.Mui-selected': {
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        color: '#00BF75',
      },
    },
  },
});

const FilterToggleExclusive = (props) => {
  const classes = useStyles();
  const handleChange = (event, newValue) => {
    props.handleChange(newValue);
  };

  return (
    <ToggleButtonGroup
      exclusive
      className={classes.root}
      value={props.groupState}
      onChange={handleChange}
    >
      {props.values.map((value) => {
        const key = (typeof value === 'string') ? value : value.key;
        return (
          <ToggleButton
            key={key}
            value={key}
          >
            {(typeof value === 'string') ? value : value.display}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

FilterToggleExclusive.defaultProps = {
  groupState: null,
};

FilterToggleExclusive.propTypes = {
  handleChange: PropTypes.func.isRequired,
  groupState: PropTypes.string,
  values: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      display: PropTypes.string,
    })),
  ]).isRequired,
};

export default FilterToggleExclusive;
